import React, { useEffect, useRef, useState } from 'react';
import { Call, MicAnnounceLine, Repeat } from 'sushiweb/Icons';
import { grey, red } from 'sushiweb/tokens/color';
import { Modal, CopyText, Confirm, Toast, Tooltip } from '..';
import { WFHCall } from '../../components/commons';
import getStore from '../../store/store';
import { viewText } from '../../images/images';
import {
  getMilliseconds,
  getFullDate,
} from '../../components/commons/CommonMethods';
import { userModel } from '../../api';

export const CallComp = (props) => {
  const [showPopup, setShowPopup] = useState(false);
  const { ordersState } = getStore().getState();
  const { isWFH } = ordersState;

  const handleClick = () => {
    setShowPopup(true);
  };

  const closePopup = () => {
    setShowPopup(false);
  };

  return (
    <React.Fragment>
      <span className='iconMarginR' onClick={handleClick}>
        <Call size={14} color={grey.z500} />
      </span>
      <Modal
        isVisible={showPopup}
        title={`${props?.calledTo} Numbers`}
        type='medium'
        handleClose={closePopup.bind(this)}
        component={<MakeCall {...props} isWFH={isWFH} />}
      />
    </React.Fragment>
  );
};

export const MakeCall = (props) => {
  const { phone_numbers = '', isWFH, orderId, userId, calledTo } = props;

  const [userNumberInfo, setUserNumberInfo] = useState(null);
  const [toast, setToast] = useState(null);
  const [showConfirmPop, setConfirmPop] = useState(null);
  const [confirmationDetails, setConfirmationDetails] = useState(null);
  const timerRef1 = useRef(null);
  const timerRef2 = useRef(null);

  const phoneNumbers = phone_numbers?.phone_string?.split(',');
  const escalationNumbers = phone_numbers?.escalation_numbers_data;

  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return () => {
      clearTimeout(timerRef1);
      clearTimeout(timerRef2);
    };
  }, []);

  const numberTempate = (number, isMerchantEscalation = false) => {
    return (
      <span data-dd-privacy='mask'>
        <CopyText
          isMerchantEscalation={isMerchantEscalation}
          title={number}
          isWFH={isWFH}
          masking={true}
          maskingCount={4}
          orderId={orderId}
          calledTo={calledTo}
        />
      </span>
    );
  };

  const unmaskUserNumber = () => {
    return makeCallForUnmaskUser('number').then((res) => {
      setUserNumberInfo(res);
      if (timerRef2.current) clearTimeout(timerRef1.current);
      timerRef2.current = setTimeout(() => {
        maskUserInfo();
      }, 100);
    });
  };

  const closeToast = () => {
    setToast({
      ...toast,
      showToast: false,
    });
  };

  const maskUserInfo = () => {
    if (!userNumberInfo || (userNumberInfo && !userNumberInfo.valid_till))
      return;
    const { valid_till } = userNumberInfo;
    const getValidMilliseconds = getMilliseconds(valid_till);
    if (timerRef1.current) clearTimeout(timerRef1.current);
    timerRef1.current = setTimeout(() => {
      setUserNumberInfo(null);
      let toastData = {
        showToast: true,
        toastType: 'error',
        toastText: userNumberInfo.message || 'Masked number validity expired!',
      };
      setToast(toastData);
    }, getValidMilliseconds * 1000);
  };

  const makeCallForUnmaskUser = (type) => {
    let queryStrings = {};
    queryStrings['order_id'] = orderId;

    return userModel
      .unmaskUserInfo(queryStrings, type)
      .then((response) => {
        if (
          !response ||
          (response && response.isError === true) ||
          (response && response.status === 'failure')
        ) {
          const toastData = {
            showToast: true,
            toastText:
              response.message ||
              'Something went wrong. please try again later!',
            toastType: 'error',
          };
          setToast(toastData);
        } else {
          return response;
        }
      })
      .catch((err) => {
        const toastData = {
          showToast: true,
          toastText:
            err.message || 'Something went wrong. please try again later!',
          toastType: 'error',
        };
        setToast(toastData);
      });
  };

  const reGeneratedMaskNumber = (details) => {
    setConfirmPop(true);
    setConfirmationDetails(details);
  };

  const closeConfirmPop = () => {
    setConfirmPop(false);
  };

  const handleConfirmClick = (action) => {
    if (action === 'cancel') {
      return this.closeConfirmPop();
    }
    setConfirmPop(false);

    return unmaskUserNumber();
  };

  if (calledTo === 'Customer') {
    return (
      <div className='pb20 pt20 flex col'>
        <div className='flex pt10'>
          {userNumberInfo ? (
            <div className='flex vCenter'>
              <CopyText
                orderId={orderId}
                title={userNumberInfo.number}
                masking={false}
                calledTo={calledTo}
              />
              {userNumberInfo?.show_reload_button && (
                <Tooltip
                  position='bottom'
                  border={false}
                  title={
                    <div
                      className='pointer'
                      onClick={reGeneratedMaskNumber.bind(
                        this,
                        userNumberInfo.masked_number_popup,
                      )}
                    >
                      <Repeat size={18} color={grey.z500} />
                    </div>
                  }
                  label='Renew Masked Number'
                />
              )}
            </div>
          ) : (
            <div className='masked'>
              xxxxxxxxxx
              <span
                className='pointer icon iconMarginL'
                onClick={unmaskUserNumber}
              >
                <img src={viewText} alt='' />
              </span>
            </div>
          )}
          {isWFH ? (
            <WFHCall
              orderId={orderId}
              userId={userId}
              pos='right'
              isUser={true}
              calledTo={calledTo}
            />
          ) : null}
        </div>

        {userNumberInfo && userNumberInfo.masked_pin ? (
          <div className='lighter pt10 col'>
            <div data-dd-privacy='mask'>
              {userNumberInfo.masked_pin.key}: &nbsp;
              <CopyText title={userNumberInfo.masked_pin.value} />
            </div>
            <div>
              PIN Expiry: &nbsp;
              <p>{getFullDate(userNumberInfo.valid_till * 1000)}</p>
            </div>
          </div>
        ) : null}

        {showConfirmPop ? (
          <Confirm
            show={showConfirmPop}
            content={confirmationDetails}
            close={closeConfirmPop}
            handleClick={handleConfirmClick}
          />
        ) : null}
        <Toast
          show={toast?.showToast}
          align='top'
          text={toast?.toastText}
          type={toast?.toastType}
          onClose={closeToast}
        />
      </div>
    );
  }

  return (
    <div>
      {phoneNumbers && phoneNumbers.length ? (
        <div className='pb20 pt20 mt10' data-dd-privacy='mask'>
          {phoneNumbers.map((number, index) => {
            return (
              <div className='pb10' key={index}>
                {numberTempate(number, false)}
              </div>
            );
          })}
        </div>
      ) : null}
      {escalationNumbers && escalationNumbers.contact_details ? (
        <div className='pt10'>
          <p className='pb10 bold huge'>Escalation Numbers: </p>
          {escalationNumbers.warning_text && (
            <p
              className={`pb20 large semiBold ${escalationNumbers.warning_text_color}`}
              data-dd-privacy='mask'
            >
              <span className='iconMarginR'>
                <MicAnnounceLine size={22} color={red.z500} />
              </span>
              {escalationNumbers.warning_text}
            </p>
          )}
          {escalationNumbers.contact_details &&
            escalationNumbers.contact_details.map((item, index) => {
              return (
                <div
                  className='row flex pb10'
                  key={index}
                  data-dd-privacy='mask'
                >
                  {item.role && (
                    <p className='bold iconMarginR capitalize'>{item.role}: </p>
                  )}
                  {numberTempate(item.phone_string, true)}
                </div>
              );
            })}
        </div>
      ) : null}
    </div>
  );
};
